/**
 * 상태 이상 정의. 수치는 `status.json`, 로직은 PlayerState 가 틱한다.
 */

import seed from './status.json';
import { emitDataReloadSoon, replaceArray, replaceRecord, requireRecord } from './catalog';

export type StatusId = 'stun' | 'slow' | 'poison';

export interface StatusDef {
  id: StatusId;
  name: string;
  icon: string;
  durationMs: number;
  moveMul?: number;
  tickMs?: number;
  tickDamage?: number;
}

export const STATUSES: Record<StatusId, StatusDef> = structuredClone(seed.STATUSES) as Record<
  StatusId,
  StatusDef
>;

export const STATUS_ORDER: StatusId[] = [...(seed.STATUS_ORDER as StatusId[])];

export function applyStatusTable(raw: unknown): void {
  const data = requireRecord(raw, 'status.json');
  replaceRecord(
    STATUSES as Record<string, StatusDef>,
    structuredClone(requireRecord(data.STATUSES, 'STATUSES')) as Record<string, StatusDef>,
  );
  if (!Array.isArray(data.STATUS_ORDER)) throw new Error('status.json: STATUS_ORDER 배열이 아닙니다');
  replaceArray(STATUS_ORDER, data.STATUS_ORDER as StatusId[]);
}

if (import.meta.hot) {
  import.meta.hot.accept('./status.json', (mod) => {
    if (!mod?.default) return;
    applyStatusTable(mod.default);
    emitDataReloadSoon();
  });
}
